import React, { useEffect, useRef } from "react";
import MaskedInput from "react-text-mask";

function PhoneMask(props) {
  const { inputRef, value, ...other } = props;
  const maskInputRef = useRef(null);

  useEffect(() => {
    const inputEl = maskInputRef.current?.inputElement;
    if (!inputEl) return;

    // Move cursor to the first empty slot
    const moveCaretToFirstEmpty = () => {
      const value = inputEl.value;
      const firstEmpty = value.indexOf("\u2000");
      if (firstEmpty !== -1) {
        requestAnimationFrame(() => {
          inputEl.setSelectionRange(firstEmpty, firstEmpty);
        });
      }
    };

    const handleFocus = () => moveCaretToFirstEmpty();

    const handleClick = (e) => {
      // if user clicks somewhere before filling all digits
      const value = inputEl.value;
      const firstEmpty = value.indexOf("\u2000");
      if (firstEmpty !== -1 && e.target.selectionStart > firstEmpty) {
        moveCaretToFirstEmpty();
      }
    };

    inputEl.addEventListener("focus", handleFocus);
    inputEl.addEventListener("click", handleClick);

    return () => {
      inputEl.removeEventListener("focus", handleFocus);
      inputEl.removeEventListener("click", handleClick);
    };
  }, []);

  return (
    <MaskedInput
      {...other}
      value={value} // <-- controlled value
      ref={(ref) => {
        maskInputRef.current = ref;
        if (ref) inputRef(ref.inputElement);
      }}
      mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={'\u2000'} // <-- Use Unicode EN QUAD (invisible, not in mask)
      showMask
    />
  );
}

export default PhoneMask;
